export const UPDATEALERTS = "alerts/UPDATEALERTS";
export const REMOVEALERT = "alerts/REMOVEALERT";
export const REMOVEALLALERTS = "alerts/REMOVEALLALERTS";
